import React from 'react';
import ViolationCategoriesLoading from './ViolationCategoriesLoading';
import ViolationCategory from './ViolationCategory';

const Content = ({ categories, selectAction }) => (
  <ul className="a-webreader-inner-report-menu list-reset my0 overflow-auto">
    {
      categories.map((category, index) => (
        <ViolationCategory key={index} index={index} category={category} data-id={category.id} onSelect={(event) => { selectAction(event.target.getAttribute('data-id')); }} last={index === categories.length - 1} />
      )) || <ViolationCategoriesLoading label={'t.loadingCategories'} />
    }
  </ul>
);

Content.defaultProps = {
  categories: [],
  selectAction: null
};

export default Content;
